module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-ThinItalic.f75e97d1.ttf";